// Grid.tsx
import React from 'react';
import Row from './Row';

interface GridProps {
  rowCivilizations: string[];
  colCivilizations: string[];
}

const Grid: React.FC<GridProps> = ({ rowCivilizations, colCivilizations }) => {

const getLetter = (i: number) => {
    return String.fromCharCode(65 + i);
}

const isLongCiv = (civ: string) => {
  return civ.length > 7;
}

const getClasses = (civ: string) => {
  return isLongCiv(civ) ? 'cell civ long' : 'cell civ';
}

  return (
    <div className='grid'>
      <div className="row">
        <div className="cell"></div>
        {colCivilizations.map((colCivilization, index) => (
          <div key={index} className={getClasses(colCivilization)}>{colCivilization}</div>
        ))}
      </div>
      {rowCivilizations.map((rowCivilization, rowIndex) => (
        <Row key={rowIndex} rowCivilization={rowCivilization} colCivilizations={colCivilizations} rowLetter={getLetter(rowIndex)} />
      ))}
    </div>
  );
}

export default Grid;